// src/modules/app-views/toolbox/pages/Init/components/tableColumns/skuColumn.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import translateX from 'utils/translateX';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
function skuColumn(buildColumnProps, options = {}) {
  const {
    key = 'sku',
    title = 'sku',
    dataIndex = 'sku',
    width = 120,
    columnProps = { sort: true, search: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    width,
    ...buildColumnProps(dataIndex, columnProps),
    render: (_, r) => r?.sku || '\u2014',
  };
}

export default skuColumn;
